export enum ButtonLoadingBehaviour {
	ForWideButton = "ForWideButton",
	ForNarrowButton = "ForNarrowButton",
}
